// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1UgV4","vLegacy":"SelectSecondary_vLegacy__M2Wbb","error":"SelectSecondary_error__3sx34","disabled":"SelectSecondary_disabled__MKXV0"};